// #ifndefall OPEN-SOURCE
/*
 * @Author: your name
 * @Date: 2021-07-13 14:49:11
 * @LastEditTime: 2022-10-11 15:17:44
 * @LastEditors: LAPTOP-JM4BAR46
 * @Description: In User Settings Edit
 * @FilePath: \newBj-admin\src\router\center-business\report.js
 */
// -- 报表管理 report
import EmptyRouterAlive from '@/layout/EmptyRouterAlive.vue';
import EmptyRouter from '@/layout/EmptyRouter.vue';
// import Test0Empty from '@/views/test/empty.vue';
export default {
  path: 'report',
  name: 'BusinessReport',
  component: EmptyRouterAlive,
  meta: {
    title: '报表管理',
  },
  children: [
    {
      path: 'sale',
      name: 'BusinessInventoryReport',
      component: EmptyRouter,
      redirect: 'sale/inventory',
      meta: {
        title: '库存日报',
      },
      children: [
        {
          path: 'inventory',
          name: 'BusinessInventoryReport',
          component: () => import('@/views/center-business/report/sale/inventory/index'),
          meta: {
            title: '库存日报',
            isCache: true
          },
          hidden: true,
        },
      ],
    },
    {
      path: 'sale',
      name: 'BusinessReportSale',
      component: EmptyRouter,
      redirect: 'sale/census',
      meta: {
        title: '销售',
        isCache: true
      },
      children: [
        {
          path: 'census',
          name: 'BusinessReportSaleCensusIndex',
          component: () => import('@/views/center-business/report/sale/census/index'),
          meta: {
            title: '销售统计表',
            isCache: true
          },
          permissionType: 'tab',
          hidden: true,
        },
        {
          path: 'analysis',
          name: 'BusinessReportSaleAnalysisIndex',
          component: () => import('@/views/center-business/report/sale/analysis/index'),
          meta: {
            title: '销售分析表',
          },
          permissionType: 'tab',
          hidden: true,
        },
        {
          path: 'goods',
          name: 'BusinessReportSaleGoodsIndex',
          component: () => import('@/views/center-business/report/sale/goods/index'),
          meta: {
            title: '销售商品统计表',
          },
          permissionType: 'tab',
          hidden: true,
        },
        {
          path: 'shop',
          name: 'BusinessReportSaleShopIndex',
          component: () => import('@/views/center-business/report/sale/shop/index'),
          meta: {
            title: '店铺销售表',
          },
          permissionType: 'tab',
          hidden: true,
        },
      ],
    },
    {
      path: 'sale',
      name: 'BusinessReportSaleCSG',
      component: EmptyRouter,
      redirect: 'sale/censusCSG',
      meta: {
        title: '销售',
        isCache: true
      },
      children: [
        {
          path: 'censusCSG',
          name: 'BusinessReportSaleCensusIndexCSG',
          component: () => import('@/views/center-business/report/sale/census/indexCSG'),
          meta: {
            title: '销售统计表',
            isCache: true
          },
          permissionType: 'tab',
          hidden: true,
        }
      ],
    },
    {
      path: 'stock',
      name: 'BusinessReportStock',
      component: EmptyRouter,
      redirect: 'stock/deliver',
      meta: {
        title: '库存',
        isCache: true
      },
      children: [
        {
          path: 'deliver',
          name: 'BusinessReportStockDeliverIndex',
          component: () => import('@/views/center-business/report/stock/deliver/index'),
          meta: {
            title: '发货汇总表',
            isCache: true
          },
          permissionType: 'tab',
          hidden: true,
        },
        {
          path: 'out',
          name: 'BusinessReportStockOutIndex',
          component: () => import('@/views/center-business/report/stock/out/index'),
          meta: {
            title: '缺货统计表',
          },
          permissionType: 'tab',
          hidden: true,
        },
      ],
    },
    {
      path: 'order',
      name: 'BusinessReportOrder',
      component: EmptyRouter,
      redirect: 'order/statistics',
      meta: {
        title: '订单',
        isCache: true
      },
      children: [
        {
          path: 'statistics',
          name: 'BusinessReportOrderIndex',
          component: () => import('@/views/center-business/report/order/statistics'),
          meta: {
            title: '订单汇总表',
            isCache: true
          },
          // permissionType: 'tab',
          hidden: true,
        },
      ]
    },
    {
      path: 'orderTimeliness',
      name: 'BusinessOrderTimeliness',
      component: EmptyRouter,
      redirect: 'orderTimeliness/average',
      meta: {
        title: '订单',
        isCache: true
      },
      children: [
        {
          path: 'average',
          name: 'BusinessOrderTimelinessAverage',
          component: () => import('@/views/center-business/report/orderTimeliness/average'),
          meta: {
            title: '处理时长表',
            isCache: true
          },
          permissionType: 'tab',
          hidden: true,
        },
        {
          path: 'onTime',
          name: 'BusinessOrderTimelinessOnTime',
          component: () => import('@/views/center-business/report/orderTimeliness/onTime'),
          meta: {
            title: '按时处理率表',
            isCache: true
          },
          permissionType: 'tab',
          hidden: true,
        },
      ]
    },
    {
      path: 'warehouse',
      name: 'BusinessOrderWarehouseEfficiency',
      component: EmptyRouter,
      redirect: 'warehouse/pickerRank',
      meta: {
        title: '仓库时效',
        isCache: true
      },
      children: [
        {
          path: 'pickerRank',
          name: 'BusinessOrderWarehousePickerRank',
          component: () => import('@/views/center-business/report/warehouse/pickerRank'),
          meta: {
            title: '拣货员排名',
            isCache: true
          },
          permissionType: 'tab',
          hidden: true,
        },
        {
          path: 'forkliftDriver',
          name: 'BusinessOrderrWarehouseForkliftDriver',
          component: () => import('@/views/center-business/report/warehouse/forkliftDriver'),
          meta: {
            title: '叉车手排名',
            isCache: true
          },
          permissionType: 'tab',
          hidden: true,
        },
      ]
    }
  ],
};
